import { set } from '@/utils/vuex'

export default {
  setToken: set('token')
}
